// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.persona.RentalManagerUserPropertyOwnershipVerificationWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyOwnershipVerificationWebApiHandler_getVerificationState,
  RentalManagerUserPropertyOwnershipVerificationWebApiHandler_getVerificationState_Path,
  RentalManagerUserPropertyOwnershipVerificationWebApiHandler_startOrResume,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  ListingAlias,
  PropertyOwnershipVerificationStartWebResponseDto,
  PropertyOwnershipVerificationStateWebResponseDto,
  StartPropertyOwnershipVerificationRequestDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface GetVerificationStateParams {
  listingAlias: ListingAlias;
}

export type RentalManagerUserPropertyOwnershipVerificationWebApiHandler_getVerificationState_Options = UseQueryOptions<
  PropertyOwnershipVerificationStateWebResponseDto,
  unknown,
  PropertyOwnershipVerificationStateWebResponseDto,
  readonly [string, GetVerificationStateParams]
>;

const RentalManagerUserPropertyOwnershipVerificationWebApiHandler_getVerificationState_GetKey = (
  getParams: GetVerificationStateParams,
) => [RentalManagerUserPropertyOwnershipVerificationWebApiHandler_getVerificationState_Path, getParams] as const;

export const RentalManagerUserPropertyOwnershipVerificationWebApiHandler_getVerificationState_queryOptions = (
  getParams: GetVerificationStateParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyOwnershipVerificationWebApiHandler_getVerificationState_GetKey(getParams),
    queryFn: () =>
      RentalManagerUserPropertyOwnershipVerificationWebApiHandler_getVerificationState(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get the property ownership verification state for a listing
 */
export const useRentalManagerUserPropertyOwnershipVerificationWebApiHandler_getVerificationState = (
  getParams: GetVerificationStateParams,
  {
    httpClient,
    ...options
  }: Omit<
    RentalManagerUserPropertyOwnershipVerificationWebApiHandler_getVerificationState_Options,
    'queryFn' | 'queryKey'
  > & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyOwnershipVerificationWebApiHandler_getVerificationState_queryOptions(getParams, {
      httpClient,
    }),
    ...options,
  });
};
useRentalManagerUserPropertyOwnershipVerificationWebApiHandler_getVerificationState.getKey =
  RentalManagerUserPropertyOwnershipVerificationWebApiHandler_getVerificationState_GetKey;

export interface RentalManagerUserPropertyOwnershipVerificationWebApiHandler_startOrResume_Args {
  postData: StartPropertyOwnershipVerificationRequestDto;
}

export type RentalManagerUserPropertyOwnershipVerificationWebApiHandler_startOrResume_Options = UseMutationOptions<
  PropertyOwnershipVerificationStartWebResponseDto,
  unknown,
  RentalManagerUserPropertyOwnershipVerificationWebApiHandler_startOrResume_Args
>;

/**
 * Start or resume a property ownership verification inquiry for a listing
 */
export const useRentalManagerUserPropertyOwnershipVerificationWebApiHandler_startOrResume = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyOwnershipVerificationWebApiHandler_startOrResume_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyOwnershipVerificationWebApiHandler_startOrResume_Args) =>
      RentalManagerUserPropertyOwnershipVerificationWebApiHandler_startOrResume(args.postData, httpClient),
  });
};
